/* @generated from adl module ferovinum.datacontracts.expense */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface ExpenseRawRecord {
  id: common_strings.StringNE;
  reference: common_strings.StringNE;
  expenseTypeCode: common_strings.StringNE;
  currency: common_strings.StringNE;
  value: common.BigDecimal;
  expenseDate: common.LocalDate;
  organisationId: common_strings.StringNE;
  feroEntity: common_strings.StringNE;
  description: common_strings.StringNE;
  notes: (string|null);
  vendor: (common_strings.StringNE|null);
  vendorReference: (common_strings.StringNE|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeExpenseRawRecord(
  input: {
    id: common_strings.StringNE,
    reference: common_strings.StringNE,
    expenseTypeCode: common_strings.StringNE,
    currency: common_strings.StringNE,
    value: common.BigDecimal,
    expenseDate: common.LocalDate,
    organisationId: common_strings.StringNE,
    feroEntity: common_strings.StringNE,
    description: common_strings.StringNE,
    notes: (string|null),
    vendor: (common_strings.StringNE|null),
    vendorReference: (common_strings.StringNE|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): ExpenseRawRecord {
  return {
    id: input.id,
    reference: input.reference,
    expenseTypeCode: input.expenseTypeCode,
    currency: input.currency,
    value: input.value,
    expenseDate: input.expenseDate,
    organisationId: input.organisationId,
    feroEntity: input.feroEntity,
    description: input.description,
    notes: input.notes,
    vendor: input.vendor,
    vendorReference: input.vendorReference,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const ExpenseRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.expense","decl":{"annotations":[{"value":{"datasetName":"raw_expenses"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseTypeCode","default":{"kind":"nothing"},"name":"expenseTypeCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseDate","default":{"kind":"nothing"},"name":"expenseDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"feroEntity","default":{"kind":"nothing"},"name":"feroEntity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"notes","default":{"kind":"nothing"},"name":"notes","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"vendor","default":{"kind":"nothing"},"name":"vendor","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendorReference","default":{"kind":"nothing"},"name":"vendorReference","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ExpenseRawRecord","version":{"kind":"nothing"}}};

export const snExpenseRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.expense", name:"ExpenseRawRecord"};

export function texprExpenseRawRecord(): ADL.ATypeExpr<ExpenseRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snExpenseRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.expense.ExpenseRawRecord" : ExpenseRawRecord_AST
};
